import ReCAPTCHA from 'react-google-recaptcha';
import styled from '@emotion/styled';
import { spacing } from '@playdapp/ui';

import recaptchaSiteKey from 'lib/recaptcha';

type Props = {
  recaptcha: string | null;
  handleChange: (token: string | null) => void;
};

const Container = styled.div<{ isHidden: boolean }>`
  display: ${({ isHidden }) => (isHidden ? 'none' : 'flex')};
  align-items: center;
  justify-content: center;
  margin-top: ${spacing.m};
`;

const GoogleReCaptcha = ({ recaptcha, handleChange }: Props) => {
  const siteKey =
    process.env.NEXT_PUBLIC_ENV === 'production'
      ? recaptchaSiteKey.production
      : recaptchaSiteKey.develop;

  return (
    <Container isHidden={!!recaptcha}>
      <ReCAPTCHA
        sitekey={siteKey}
        onChange={handleChange}
        theme="light"
        type="image"
        hl="en"
      />
    </Container>
  );
};

export default GoogleReCaptcha;
